/* global moment */

import { defaultEventProjection } from 'assets/projections';
import { get } from 'lodash';

import './style.less';

export default function ($log, $q, $scope, $stateParams, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  function activate() {
    $log.debug('Incomplete Evaluations Component Activated');
    vm.error = {};
    vm.loaded = false;
    vm.profileUid = $stateParams.id;

    const promiseArray = [
      ApiClass.eventsGet(
        { eventType: false, pastEvents: false },
        {},
        {
          queryParams: {
            registration: true,
            filters: JSON.stringify({ includeArchived: true, includePastEvents: true }),
            ...defaultEventProjection.reduce((acc, prop) => {
              acc[`projection:${prop}`] = 1;

              return acc;
            }, {})
          }
        }
      ),
      ApiClass.coursesGet(
        { courseType: false },
        {},
        {
          queryParams: {
            internal: true,
            vendor: true,
            filters: JSON.stringify({ requireProgress: true, includeExpired: true })
          }
        }
      ),
      ProfileClass.profileComplete,
    ];

    $q.all(promiseArray)
      .then(([{ data: { events } }, { data: { courses } }, profileComplete]) => {
        $log.debug('Incomplete Evaluations Data:', { events, courses });

        $scope.disableButtons = get(profileComplete, 'company.preferences.read_only.user.evaluation', false);

        vm.evaluations = [];
        const courseEvaluations = courses.filter(
          course => course && course.progress && course.progress.cert && !course.progress.reviewed
        );

        const eventEvaluations = events.filter(event => {
          if (!event) return;

          const eventTime = moment(event.delivery_date || event.start_time || event.date).valueOf();
          const monthAgo = moment()
            .subtract(1, 'months')
            .valueOf();
          const now = moment().valueOf();
          const inRange = monthAgo < eventTime && eventTime < now;

          return (
            inRange &&
            event.registration &&
            (event.registration.completed || event.registration.evalCount) &&
            !event.registration.reviewed
          );
        });

        vm.evaluations.push(...[...courseEvaluations, ...eventEvaluations]);
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/incompleteEvaluations/controller.js